import { ScorecardPageView } from './ScorecardPageView';
import { useScorecardPage } from './hooks/useScorecardPage';

export function ScorecardPageContainer() {
  const viewProps = useScorecardPage();
  return <ScorecardPageView {...viewProps} />;
}
